module.exports = __webpack_public_path__ + "09e025f44366e7d41dfb97cf5a8a020a.svg";